module.exports = __webpack_public_path__ + "static/media/T12_Montenapoleone.29acea97.png";